var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../panel/align-panel.js';
import '../panel/font-family-panel.js';
import { WithDisposable } from '@blocksuite/lit';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let EdgelessChangeTextButton = class EdgelessChangeTextButton extends WithDisposable(LitElement) {
    constructor() {
        super(...arguments);
        this.texts = [];
    }
    render() {
        return html `<div class="change-text-container">
      <edgeless-change-text-menu
        .elements=${this.texts}
        .elementType=${'text'}
        .surface=${this.surface}
      ></edgeless-change-text-menu>
    </div>`;
    }
};
EdgelessChangeTextButton.styles = css `
    :host {
      display: flex;
    }

    .change-text-container {
      display: flex;
    }
  `;
__decorate([
    property({ attribute: false })
], EdgelessChangeTextButton.prototype, "texts", void 0);
__decorate([
    property({ attribute: false })
], EdgelessChangeTextButton.prototype, "page", void 0);
__decorate([
    property({ attribute: false })
], EdgelessChangeTextButton.prototype, "surface", void 0);
EdgelessChangeTextButton = __decorate([
    customElement('edgeless-change-text-button')
], EdgelessChangeTextButton);
export { EdgelessChangeTextButton };
//# sourceMappingURL=change-text-button.js.map